import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  requirements: {
    categories: [],
    products: []
  },
  promocodes: [],
  isLoading: false
})

const getters = {
  requirements: (state) => state.requirements,
  promocodes: (state) => state.promocodes,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_REQUIREMENTS(state, payload) {
    state.requirements.categories = payload.categories
    state.requirements.products = payload.products
  },
  SET_PROMOCODES(state, payload) {
    state.promocodes = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchRequirements({ commit, dispatch }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(`${adminBaseUrl}/requirements/promocodes`)
      .then((res) => {
        commit('SET_REQUIREMENTS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  fetchPromocodes({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_PROMOCODES', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createPromocode({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }

    vm.componentLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/promocodes`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/promocodes')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.componentLoading = false
      })
  },
  deletePromocode(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/promocodes/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchPromocode(_context, { id, vm }) {
    vm.componentLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/promocodes/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.form.name_en = message.name_en
        vm.form.name_ru = message.name_ru
        vm.form.code = message.code
        vm.form.sale = message.sale
        vm.form.start = new Date(message.start)
        vm.form.end = new Date(message.end)

        if (message.category_id) {
          vm.active = 'Categories'
          vm.form.category_id = message.category_id
        } else if (message.product_id) {
          vm.active = 'Products'
          vm.form.product_id = message.product_id
        }
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.componentLoading = false
      })
  },
  updatePromocode({ commit }, { id, payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    commit('SET_LOADING', true)
    axiosWithToken
      .post(`${adminBaseUrl}/promocodes/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/promocodes')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
